import { Filter, useDevicesLocationQuery } from "generated/graphql";
import { DeviceFilterState, useDeviceFilterValue } from "elements";
import { useSelector } from "react-redux";
import { State } from "store";
import {
  constructFilterList,
  constructPreFilter,
  constructSortList
} from "utilities/filters/deviceFilters";
import { UseQueryArgs } from "urql";
import { useContext } from "react";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";

export type PreFilter = {
  [key in keyof DeviceFilterState]: string | null | Filter;
};

export const useDevices = (
  inBounds: boolean = false,
  search: string = "",
  preFilter: PreFilter = {},
  from: number = 0,
  requestPolicy?: UseQueryArgs["requestPolicy"]
) => {
  const [filterValues] = useDeviceFilterValue();
  const { tenant } = useContext(SelectedTenantContext);
  const tenantId = tenant?.id ?? "";
  const bounds = useSelector((state: State) => state.devicesMap.bounds);
  const searchParams: Filter[] = search
    ? search.split(" ").map(word => ({ searchTerm: word }))
    : [{ searchTerm: "" }];

  const filterList = constructFilterList(filterValues, tenantId);
  const preFilterList = constructPreFilter(preFilter);

  const constructBoundsFilter = () => {
    let filters = {
      AND: [
        ...filterList,
        ...preFilterList,
        inBounds
          ? {
              field: "geohash",
              within: bounds
            }
          : {},
        search
          ? {
              AND: searchParams
            }
          : {}
      ]
    };
    if (filterValues["model"] === "") {
      filters.AND.push({ field: "hardwareModel", exists: false });
    }
    return filters;
  };

  const requestPolicyOpts = requestPolicy ? { requestPolicy } : {};

  return useDevicesLocationQuery({
    variables: {
      sort: constructSortList(filterValues),
      from,
      boundsFilter: constructBoundsFilter(),
      noLocationFilter: {
        AND: [
          ...filterList,
          ...preFilterList,
          {
            field: "geohash",
            exists: false
          }
        ]
      },
      aggregations: [
        {
          term: "hardwareModel"
        },
        {
          term: "softwareVersion"
        },
        {
          term: "site"
        },
        {
          term: "connected"
        }
      ]
    },
    ...requestPolicyOpts
  });
};
